
export default {
    code: 'BUS_US_PALO_ALTO_NETWORKS'
}
